import ReactDOM from 'react-dom/client';
import React from 'react';
import { v2Component } from '../../../index';
import { TenantContext } from '../../../context/tenant-context';
import { PayLaterPlanMessaging } from './pay-later-plan-messaging';
import { StripeContextProvider } from '../../../context/stripe-context';

export function initPayLaterPlanMessaging() {
  const elements = document.getElementsByName('stripe-payment-method-messaging');
  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');

      const root = ReactDOM.createRoot(element);
      const bootstrap = (mutations: MutationRecord[]) => {
        if (mutations.length === 0 || mutations.find((r) => r.attributeName === 'data-price')) {
          const { tenant, contextPath, ...rest } = Object.assign({}, element.dataset) as any;
          const props = {
            ...rest,
            amount: parseFloat(rest.price),
          };

          root.render(
            v2Component(
              <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
                <StripeContextProvider>
                  <PayLaterPlanMessaging {...props} />
                </StripeContextProvider>
              </TenantContext.Provider>,
            ),
          );
        }
      };

      const observer = new MutationObserver(bootstrap);
      observer.observe(element, { attributes: true });
      bootstrap([]);
    }
  });
}
